import { languages } from "../constants";
import { isMongoObjectId } from "./phone";

const normalizeDescription = (description) => {
  if (
    description &&
    typeof description === "object" &&
    !Array.isArray(description)
  ) {
    return languages.reduce((acc, lang) => {
      acc[lang] = description[lang] ?? "";
      return acc;
    }, {});
  }

  const text = typeof description === "string" ? description : "";
  return languages.reduce((acc, lang) => {
    acc[lang] = text;
    return acc;
  }, {});
};

/** Strip client UUIDs and normalize fields before PATCH. */
export const sanitizeVideosForApi = (videos = []) =>
  videos.map(({ _id, description, type, url }) => {
    const entry = {
      description: normalizeDescription(description),
      type: Number(type) || 1,
      url: url ?? "",
    };

    if (isMongoObjectId(_id)) {
      entry._id = _id;
    }

    return entry;
  });
